import { storePartners } from '@/mocks/faq';

export default function StorePartners() {
  return (
    <section className="w-full min-h-screen flex flex-col justify-center py-20 md:py-28 bg-gradient-to-bl from-secondary-50 via-secondary-100/60 to-primary-100">
      <div className="w-full px-6 md:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
            清文華泉合作購書通路
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            清文華泉的出版書籍可透過下列合作通路查找與購買。各書籍在不同平台的上架狀態可能不同，實際商品資訊、價格、庫存與銷售方式，請以各通路頁面為準。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {storePartners.map((store) => (
            <a
              key={store.name}
              href={store.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-50 border border-background-200 mb-3 group-hover:border-primary-200 transition-colors duration-300">
                <i className="ri-store-2-line text-xl text-foreground-600 group-hover:text-primary-600 transition-colors duration-300"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap">
                {store.name}
              </span>
              <span className="text-[11px] text-foreground-400 mt-1 line-clamp-2 leading-relaxed">
                {store.description}
              </span>
            </a>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block max-w-lg mx-auto px-8 py-6 rounded-xl bg-background-100 border border-background-200">
            <h3 className="text-sm font-medium text-foreground-800 mb-2">
              品牌經銷與合作洽詢
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed">
              如有清文華泉品牌經銷、內容合作、媒體或其他相關合作需求，請透過官方聯絡方式提出詢問。品牌經銷與合作方案詳情請直接聯繫洽詢。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}